
class SimpleFilter {
  constructor(form) {
    this.form = form;
    this.key = form.dataset.simpleFilter;
    this.content = document.querySelector(`[data-simple-filter-content="${this.key}"]`);


    this.init();
  }

  init() {
    this.bind();

  }

  bind() {
    this.bindInputs();
  }

  bindInputs() {
    const instance = this;
    this.form.querySelectorAll('select[data-simple-filter-field]').forEach((select) => {
      select.addEventListener('change', (e) => {
        const value = select.value;
        instance.showBy(value.toString());
      });
    });
  }

  showBy(value) {
    this.content.querySelectorAll('[data-simple-filter-item]').forEach((item) => {
      const itemValue = item.dataset.simpleFilterItem;
      if (value && itemValue !== value) {
        item.classList.add('_hide');
      } else {
        item.classList.remove('_hide');
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', (e) => {
  document.querySelectorAll('[data-simple-filter]').forEach((filter) => {
    new SimpleFilter(filter);
  })
});

